var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.951,
    height: 20,
    viewBox: "0 0 19.951 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sign_out",
    d: "M21.951,11H12.414l3.293-3.293L14.293,6.293l-5,5L8.586,12l.707.707,5,5,1.414-1.414L12.414,13h9.536a10,10,0,1,1,0-2Z",
    transform: "translate(-2 -2)",
    fill: "#416a9a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/Sign_out.d27bf19ce92a86501ce74db55bdfe303.svg";
export { ForwardRef as ReactComponent };